import React, { useEffect } from 'react';
import { Order } from '@baemingo/order-status-events/dist/types';

import * as actions from '~actions';
import { useOrderStatusUniverse } from '~Components/OrderStatusUniverse';
import { useDispatch, useSelector } from '~Hooks';
import { useStorage } from '~Components/Storage';

interface InstanceProps {
  order: Order;
}

const OrderInstance: React.FunctionComponent<InstanceProps> = ({ order }) => {
  const dispatch = useDispatch();
  const prints = useSelector((state) => state.POSPrintQueue);
  const [{ KDSBongOnOrderStatus }] = useStorage();

  // Print physical bong on specified order status
  useEffect(() => {
    if (!KDSBongOnOrderStatus || KDSBongOnOrderStatus !== order.status) {
      return;
    }

    const print = prints.find((p) => p.orderId === order.id);

    if (!print) {
      return;
    }

    dispatch(actions.printQueueWithOrderId(order.id));
  }, [order.status]);

  return null;
};

export const OrderStatusManager = () => {
  const universe = useOrderStatusUniverse();

  const orders = universe.orders;

  return (
    <>
      {orders.map((o) => (
        <OrderInstance order={o} key={o.id} />
      ))}
    </>
  );
};
